"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _Hr = _interopRequireDefault(require("../Typography/Hr"));
var _IconButton = _interopRequireDefault(require("../Buttons/IconButton"));
var _PortalContent = _interopRequireDefault(require("../Portal/PortalContent"));
var _Headings = require("../Typography/Headings");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TitleWrapper = (0, _styledComponents["default"])(_Box["default"]).attrs(function (props) {
  return {
    d: "flex",
    alignItems: props.alignItems || "center"
  };
}).withConfig({
  displayName: "PageTitle__TitleWrapper",
  componentId: "sc-1421wva-0"
})(["justify-content:flex-start;position:relative;gap:", ";", ""], function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.withBackArrow && (0, _styledComponents.css)(["padding-left:28px;"]);
});
var BackArrowWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PageTitle__BackArrowWrapper",
  componentId: "sc-1421wva-1"
})(["position:absolute;top:50%;left:-10px;transform:translateY(-50%);", ""], function (props) {
  return props.alignTop && (0, _styledComponents.css)(["top:12px;"]);
});
var Title = (0, _styledComponents["default"])(_Headings.Heading1).withConfig({
  displayName: "PageTitle__Title",
  componentId: "sc-1421wva-2"
})(["margin-bottom:0;"]);
Title.displayName = "PageTitle.Title";
var propTypes = {
  /** Then this function is passed, a back arrow is added and the function is called on click */
  onBackClick: _propTypes["default"].func,
  /** When true, the back arrow aligns to the top of the title */
  alignBackArrowTop: _propTypes["default"].bool,
  /** A String that is added as title */
  title: _propTypes["default"].string,
  /** Content inside the Title. If "title" is also passed, children come after it, horizontally */
  children: _propTypes["default"].node,
  /** When true a separator is added after the header */
  withSeparator: _propTypes["default"].bool
};
var PageTitle = function PageTitle(_ref) {
  var onBackClick = _ref.onBackClick,
    title = _ref.title,
    children = _ref.children,
    withSeparator = _ref.withSeparator,
    alignBackArrowTop = _ref.alignBackArrowTop;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_PortalContent["default"], {
    containerId: "header-portal"
  }, /*#__PURE__*/_react["default"].createElement(TitleWrapper, {
    withBackArrow: (0, _isFunction["default"])(onBackClick)
  }, (0, _isFunction["default"])(onBackClick) && /*#__PURE__*/_react["default"].createElement(BackArrowWrapper, {
    alignTop: alignBackArrowTop
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    name: "ArrowLeft",
    variant: "transparent",
    color: "text",
    onClick: onBackClick
  })), title && /*#__PURE__*/_react["default"].createElement(Title, null, title), children)), withSeparator && /*#__PURE__*/_react["default"].createElement(_Hr["default"], {
    mB: "none"
  }));
};
PageTitle.propTypes = propTypes;
PageTitle.Title = Title;
var _default = PageTitle;
exports["default"] = _default;